







import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		nr: Number,
	},
	data() {
		return {
			storeObject: NAME,
			apiProvider,
			emptyObject: {
				value: null,
				text: null,
				nr: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: any) {
			return {
				value: data.OZAKAZKA_ID,
				text: data.X_OZAKAZKA_PZN_ZKT,
				nr: data.OZAKAZKA_NR,
			};
		},
	},
});
